// import Vue from 'vue';
// import VueLang from '@eli5/vue-lang-js'
//
// Vue.use(VueLang, {
//     messages: window.messages, // Provide locale file
//     locale: window.default_language, // Set locale
//     fallback: window.fallback_locale // Set fallback lacale
// })

export default {
   data () {
    return {

        floatingPrecision: window.default_locale == 'hu' ? 0 : 2

    }
   },
   created: function () {
    //   console.log('mixin loading...');

   },
    methods: {
               __(key, values) {
            if (!key.startsWith('__JSON__.')) {
                key = '__JSON__.' + key;

            }
            // console.log(key, this.$t(key));
            // Lefordítjuk
            let translated = this.$t(key, values);

            // Ha nincs találat, $t visszaadja magát a kulcsot
            if (translated === key && key.startsWith("__JSON__.")) {
                // Levágjuk az __JSON__. előtagot
                return key.replace("__JSON__.", "");
            }

            return translated;
        },

        // __(text) {
        //     // console.log(text);
        //     // console.warn(this.trans.get(text));
        //     // if (this.$trans(text) == text) {
        //     if ($t(text) == text) {
        //          // console.log('[1]');
        //         return (text.replace("__JSON__.",""))
        //     } else {
        //         // console.log('[2]');
        //         return ($t(text));
        //     }
        // }
    }
}
